import 'hammerjs';
import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';

import { AppModule } from './app/app.module';
import { environment } from './environments/environment';

import 'hammerjs';

type ThemeConfig = {
    primary: string;
    accent: string;
    warn: string;
    surface: string;
    surfaceVariant: string;
    onSurface: string;
    outline: string;
};

declare global {
    interface Window {
        __SWARM_THEME__?: Partial<ThemeConfig>;
    }
}

if (environment.production) {
    enableProdMode();
}




platformBrowserDynamic()
    .bootstrapModule(AppModule)
    .catch((err) => { });
